export const getExpirationDate = (createdAt: Date) => {
  const expirationDate = new Date(createdAt);
  // Added 7 days to the task.created_at date to get the expiration date for the link
  expirationDate.setDate(expirationDate.getDate() + 7);
  return expirationDate;
};

export const formatExpirationDate = (date: Date) => {
  const now = new Date();
  const diff = date.getTime() - now.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / 1000 / 60) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return `${days} ${hours} ${minutes} ${seconds}`;
};
